import domReady from "@wordpress/dom-ready";

domReady(() => {
	const faqs = document.querySelectorAll(".wp-block-qasas-companion-faq");
	if (!faqs.length) return;

	faqs.forEach((faq) => {
		const question = faq.querySelector(
			".wp-block-qasas-companion-faq-question",
		);
		question.addEventListener("click", () => {
			faq.classList.toggle("is-open");
		});
	});
});
